import { render, staticRenderFns } from "./BtnJustificativaDesconto.vue?vue&type=template&id=05da9766&"
import script from "./BtnJustificativaDesconto.vue?vue&type=script&lang=js&"
export * from "./BtnJustificativaDesconto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports